/* 
 * @author Mateusz Mieszczak <mateusz.mieszczak at bossbyte.com>
 * @copyright BossByte Web Application
 */


app.controller('UserSettings', function ($scope, settingsService, $rootScope,_$breadcrumbs) {

    $scope.data = {};

    $scope.init = function () {
        var promise = settingsService.get();

        promise.then(
                function (payload) {
                    $scope.data = payload.data;                                                                                   
                    
                    _$breadcrumbs.push($scope.data.name + " " + $scope.data.surname);
                    
                    $scope.data.unit = $scope.data.unit ? $scope.data.unit : "Nieokreślona";
                    $scope.data.subunit = $scope.data.subunit ? $scope.data.subunit : "Nieokreślona";                    
                },
                function (errorPayload) {
                    $rootScope.notification.show('error', 'Wystąpił błąd podczas próby pobrania danych użytkownika');
                });
    };

    $scope.init();        
    
    $scope.check = function(form){        
        if (form.$valid) {            
            return true;
        } else {
            angular.forEach(form.$error, function(field) {                                   
                angular.forEach(field, function(f) { 
                    f.$setDirty();
                    f.$setTouched();
                });
            });        
            $rootScope.notification.show('error', 'Formularz nie został prawidłowo wypełniony');
            return false;
        }
    };
    
    $scope.save = function(form){
        var promise = settingsService.set($scope.data);

        promise.then(
            function (payload) {
                var code = payload.data.code ? 'success' : 'error';
                if(code == 'error')
                    $rootScope.notification.show(code,payload.data.msg);
                else{     
                    if(typeof payload.data.newpassword != "undefined"){
                        top.location.href = "/";
                    }else{
                        $rootScope.notification.showAfterRedirect('base',{},code, payload.data.msg);
                    }
                }
            });
    };
});
                  